import { Injectable } from '@angular/core';

import { EncryptorService } from '../encryptor/encryptor.service';
import { APIService } from "../api/api.service";
import { CommonService} from "../common/common.service";
import { EventsService } from '../events/events.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class CenterService {
  location: any = {};
	data: any = {};
	village_minimum_order:any;
	public deliveryTimings: Array<{ timing: string; timestamp: number }> = [];
	public deliveryDates: Array<{ timing: string; timestamp: number }> = [];
  platform_type: any;
  centerData: any = {};

  constructor(public storage: EncryptorService,
		public api: APIService,
		public commin: CommonService,
    public events: EventsService,
    public platform: Platform,
    ) {
      this.initCenter();
      this.getCenterData();
      console.log("Center Data: ", this.data);


      this.events.getObservable().subscribe((data) => {
         this.getCenterData();
      })



     }

     initCenter() {
      this.data = this.storage.getObject("centerData");
      this.location = this.storage.getObject("centerLocation");
      this.api
        .postReq("/center/status", {})
        .then((res: any) => {
          this.fetchData();
        })
        .catch(err => {
          this.fetchData();
          // this.location = {};
          // this.data = {};
           // this.save();  
            console.log('yes1'); 
            console.log('yes data'+JSON.stringify(this.data));       
        });
    }

    fetchData() {
      this.getDeliveryTimings();
      this.getLocation();
    }

    isOkay() {
      return !!this.location.village && !!this.location.mandal && !!this.location.district;
    }
    save() {
      
        this.storage.setObject("centerData", this.data);
        
      if(Object.keys(this.location).length === 0 && this.location.constructor === Object)
      {

      }
      else
      {
        this.storage.setObject("centerLocation", this.location);        
      }

    }
  getLocation() {
      this.api
        .postReq("/center/location", {})
        .then((res: any) => {
          this.location = res.data;
          console.log(this.location);
            this.save();
        })
        .catch(err => {
          //this.location = {};
           console.log('yes3');
        })
        .then(() => {

        });
    }
  
    setLocation(data) {
      this.location = data;
      this.save();
    }
  
    getDeliveryTimings() {
      this.api
        .postReq("/center/timings/order", {})
        .then((res: any) => {
          this.deliveryTimings = res.data;
        })
        .catch(err => console.log(err));
      this.api
        .postReq("/center/timings/local-products", {})
        .then((res: any) => {
          this.deliveryDates = res.data;
        })
        .catch(err => console.log(err));
    }
  
    setCenterData(data) {
      this.data = data;
      this.save();
    }

    getCenterData() {
      this.platform_type = this.platform.platforms();
  
      this.api
        .postReq('/center', {
          platform_type: this.platform_type,
        })
        .then((res: any) => {
          if (res.status == 'success') {
            this.centerData = res.data;
            this.setCenterData(this.centerData);
          } else {
            //this.commin.toastMsg('Something error occured');
          }
        })
        .catch((err) => {
          //this.commin.toastMsg(err.message);
        });
    }
  
}
